import React, { Component } from "react";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import MessageBoardTodayContainer from "../../Containers/MessageBoardTodayContainer";
import MessageBoardFooter from "./MessageBoardFooter";
import MessageBoardHeader from "./MessageBoardHeader";
import TrackComment from "~/Components/Elements/TrackComment";

import "../../css/tracks.less";
import "./MessageBoardPage.less";

class MessageBoardTodayPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
    };
  }

  render() {
    return (
      <div className="page-message-board">
        <MessageBoardHeader menu={false}>Today</MessageBoardHeader>
        <Row>
          <Col xs={12}>
            <div className="">
              <MessageBoardTodayContainer
                render={({ topics }) => (
                  <div>
                    {topics.length > 0 &&
                      topics.map((comment) => (
                        <div key={comment.id}>
                          <TrackComment addRe={true} comment={comment} />
                        </div>
                      ))}
                    {topics.length === 0 && (
                      <div>
                        No messages have been posted today. Check the <Link to="/message-board/">most recent here</Link>.
                      </div>
                    )}
                  </div>
                )}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <MessageBoardFooter />
          </Col>
        </Row>
      </div>
    );
  }
}

export default MessageBoardTodayPage;
